import React, { useEffect, useState } from 'react';
import styles from './sidebar.module.css';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCarSide, faHandHoldingDollar, faLink, faBookBookmark, faMoneyBill, faMoneyBill1, faRightFromBracket, faRoad, faRoute, faSuitcaseRolling, faTaxi, faUserNurse, faUsers, faUser } from '@fortawesome/free-solid-svg-icons';
import { faSquarespace } from '@fortawesome/free-brands-svg-icons';
import Logout from '../../page/logout/Logout';
import ThemeToggle from '../../components/theme/theme';
import { useAuth } from '../../utilities/auth/auth';
import ProfileModal from '../../page/profile/Profile';

const links = [
    { path: '/dashboard', label: 'Dashboard', icon: faSquarespace },
    {
        label: 'Ride',
        icon: faCarSide,
        subLinks: [
            { path: '/rides/request', label: ' Request List', icon: faMoneyBill1 },
            { path: '/rides/daily', label: 'Daily', icon: faTaxi },
            { path: '/rides/today', label: 'Statistics', icon: faSuitcaseRolling },
            { path: '/rides/map', label: ' Booking Locations', icon: faMoneyBill1 },
        ]
    },
    { path: '/drivers', label: 'Driver', icon: faUserNurse },
    { path: '/passengers', label: 'Passenger', icon: faUsers },
    { path: '/bulkbooking', label: 'Bulk Booking', icon: faUsers },
    {
        label: 'Outstation',
        icon: faSuitcaseRolling,
        subLinks: [
            // { path: '/outstation/routes', label: 'Routes', icon: faRoad },
            { path: '/outstation/bookings', label: 'Booking', icon: faBookBookmark },
            { path: '/outstation/driverlocation', label: 'Driver location', icon: faBookBookmark },
        ]
    },
    {
        label: 'Tourism',
        icon: faSuitcaseRolling,
        subLinks: [
            // { path: '/outstation/routes', label: 'Routes', icon: faRoad },
            { path: '/tourism/operator', label: 'Operator', icon: faBookBookmark },
            { path: '/tourism/package', label: 'Package', icon: faBookBookmark },
        ]
    },
    // { path: '/tourism/package', label: 'Tour Package', icon: faRoute },
    { path: '/zone/zones', label: 'Zones', icon: faRoute },

    {
        label: 'Finance',
        icon: faMoneyBill,
        subLinks: [
            { path: '/finance/driver_fees', label: 'Driver Fees', icon: faMoneyBill1 },
            { path: '/finance/price', label: ' Pricing', icon: faHandHoldingDollar }
        ]
    },
    {
        label: 'Logs',
        icon: faMoneyBill,
        subLinks: [
            { path: '/logs/pricing', label: 'pricing logs', icon: faMoneyBill1 },
        ]
    },
    { path: '/system_maintenance', label: 'System maintenance', icon: faLink },
    { path: '/Driverslocation', label: 'Online Drivers', icon: faUserNurse },
    // { path: '/blocation', label: 'Booking Locations', icon: faUserNurse },
    // {
    //     label: 'BookingStats',
    //     icon: faMoneyBill,
    //     subLinks: [
    //         { path: '/blocation/map', label: ' Booking Locations', icon: faMoneyBill1 },
    //         { path: '/blocation/time', label: ' Booking Time', icon: faMoneyBill1 },
    //     ]
    // },
    { path: '/notifications', label: 'Notifications', icon: faUserNurse },
    { path: '/appbundle', label: 'App Bundle', icon: faUserNurse }

];

const Sidebar = ({ setOpen, open, onLogoutClick }) => {
    const location = useLocation();
    const { user } = useAuth()
    const [showProfileModal, setShowProfileModal] = useState(false);
    const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => setIsSmallScreen(window.innerWidth <= 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);


    const [subLink, setSubLink] = useState({ ride: false, outstation: false, finance: false, logs: false, tourism: false, bookingstats: false });

    const handleClick = () => {
        if (window.innerWidth <= 768) setOpen(false);
    };

    const toggleSubLink = (section) => {
        setSubLink((prev) => {
            const updatedState = Object.keys(prev).reduce((acc, key) => {
                acc[key] = key === section ? !prev[section] : false;
                return acc;
            }, {});

            return updatedState;
        });
    }

    const isActive = (path) => {
        return location.pathname === path || location.pathname.startsWith(`${path}/`);
    };

    const isActiveP = (paths) => {
        return paths.some(path => isActive(path));
    };

    const handleProfileClick = () => {
        setShowProfileModal(true);
        // if (window.innerWidth <= 768) setOpen(false);
    };
    return (
        <div className={styles.sidebar}>
            <div className={styles.linkContainer}>
                {links.map((link, index) => (
                    link.subLinks ? (
                        <div key={index}>
                            <div role="button" tabIndex="0"
                                className={`${styles.link} ${isActiveP(link.subLinks.map(sub => sub.path)) ? styles.activeDiv : ""}`}
                                onClick={() => toggleSubLink(link.label.toLowerCase())}
                            >
                                <FontAwesomeIcon icon={link.icon} className={styles.icon} />
                                {open && link.label}
                            </div>
                            <div
                                className={`${styles.submenu} 
                             ${subLink[link.label.toLowerCase()] ? styles.open : ""}`}
                                style={{ marginLeft: open ? "40px" : "0px" }}>
                                {link.subLinks.map((sub, subIndex) => (
                                    <Link key={subIndex}
                                        to={sub.path}
                                        className={`${styles.link} ${isActive(sub.path) ? styles.active : ''}`}
                                        onClick={handleClick}>
                                        <FontAwesomeIcon icon={sub.icon} className={styles.icon} />
                                        {open && <span>{sub.label}</span>}
                                    </Link>
                                ))}
                            </div>
                        </div>
                    ) : (
                        <Link key={index}
                            to={link.path}
                            className={`${styles.link} ${isActive(link.path) ? styles.active : ''}`}
                            onClick={handleClick}>
                            <FontAwesomeIcon icon={link.icon} className={styles.icon} />
                            {open && link.label}

                        </Link>
                    )
                ))}
                <label>
                    <ThemeToggle />
                </label>
            </div>
            {!isSmallScreen && <div className={styles.profileSection}>
                <button
                    className={styles.profileButton}
                    onClick={handleProfileClick}
                >
                    <div className={styles.userImage}>
                        {user?.username?.[0]?.toUpperCase() || 'U'}
                    </div>
                    {open && (
                        <div className={styles.userInfo}>
                            <span className={styles.userName}>{user?.username || 'User'}</span>
                            <span className={styles.userRole}>{user?.role || 'Admin'}</span>
                        </div>
                    )}
                    <FontAwesomeIcon icon={faUser} className={styles.profileIcon} />
                </button>
            </div>}

            {/* Profile Modal */}
            {showProfileModal && (
                <ProfileModal
                    onClose={() => setShowProfileModal(false)}
                    user={user}
                />
            )}
            {/* <div className={styles.logout}>
                <div className={styles.userinfo}>
                    <div className={styles.userImage}>
                        {user?.username?.[0]}
                    </div>

                </div>
            </div> */}
            {/* <button className={styles.logout} onClick={() => {
                window.innerWidth <= 768 && setOpen(false)
                onLogoutClick()
            }}>
                {open && <>
                    Logout
                </>}
                <FontAwesomeIcon icon={faRightFromBracket} className={styles.icon} />
            </button> */}

        </div>
    );
};

export default Sidebar;
